import React from 'react';
import {BrowserRouter} from "react-router-dom";
import {ThemeProvider} from '@mui/material/styles';
import {themeOptions} from './constants/theme';
import {AppRoutes} from './components/common/AppRoutes';

function App() {
    return (
        <ThemeProvider theme={themeOptions}>
            <BrowserRouter>
                <AppRoutes />
            </BrowserRouter>
        </ThemeProvider>
    );
}

export default App;
